import {Injectable} from '@angular/core';
import { UrlTree } from '@angular/router';
import {select, Store} from '@ngrx/store';
import { combineLatest, Observable, take } from 'rxjs';
import {map} from 'rxjs/operators';
import * as fromPtCore from '../store/reducers/pt-core.reducer';
import * as PtCoreActions from '../store/actions/pt-core.actions';
import * as PtCoreSelectors from '../store/selectors/pt-core.selectors';
import {PtUiAppRoutes} from '@pt/pt-models';
import {UrlUtils} from "../utils/url.utils";
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService {
  constructor(
    private store: Store<fromPtCore.CoreState>,
    private localStorageService: LocalStorageService
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    this.localStorageService.setLatestPage(window.location.href);

    return combineLatest([
      this.store.pipe(select(PtCoreSelectors.routesNavigationAllowed))
    ]).pipe(
      take(1),
      map(([routesNavigationAllowed]) => {
        if (!routesNavigationAllowed) {
          this.store.dispatch(
            PtCoreActions.logoutAndClearData({
              route: [PtUiAppRoutes.LOGIN],
              domain: UrlUtils.getDomainIfExists(),
            })
          );
          return false;
        }

        return true;
      })
    );
  }
}
